/**
 * Handles the 'skr-search-button-click' custom event triggered on the trip search button is clicked
 * Decodes the query string and pushes data to the dataLayer for tracking.
 *
 * @param {CustomEvent} event - The custom event triggered by the search button.
 * @param {Object} event.detail - The details of the custom event.
 * @param {string} event.detail.props - The query string containing parameters.
 */
function handleSkrSearchButtonClick(event) {
    const queryString = event.detail.props;
    const decodedString = decodeURIComponent(queryString);
    const params = new URLSearchParams(decodedString);

    let destination = 'n/A';
    try {
        const destinationParam = params.get('countries');
        if (destinationParam) {
            destination = JSON.parse(destinationParam);
        }
    } catch (e) {}

    let formattedDate = 'n/A';
    try {
        const dateRangeParam = params.get('date_range');
        if (dateRangeParam) {
            const dateRange = JSON.parse(dateRangeParam);
            const startDate = new Date(dateRange[0]);
            formattedDate = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}`;
        }
    } catch (e) {}

    dispatchGtmEvent({
        event: 'use_search',
        reiseziel: destination,
        abreisezeitraum: formattedDate
    });
}

// Listen for the custom 'skr-search-button-click' event
window.addEventListener('skr-search-button-click', handleSkrSearchButtonClick);

define("skr/tracking/useSearch", function(){});

